<script setup>
import { useStore } from "vuex";

const store = useStore();

const toDevices = () => {
  store.dispatch("devices/clearbulkUploadData");
};
</script>

<template>
  <section class="content-header">
    <div class="row">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <router-link
              :to="{ name: 'devices' }"
              style="float: right"
              type="button"
              class="btn btn-success"
              @click="toDevices"
            >
              BACK TO DEVICES PAGE
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style></style>
